import { gql } from '@apollo/client';
import { IAddressNullable, IBaseEntity, IWelfareOffice } from '@dokucoach/common-types';
import { welfareOfficeBaseData } from './query/welfareOffices';

export type WelfareOfficeListData = {
  id: string;
  deletedAt?: Date | null;
  name: string;
  address?: IAddressNullable | null;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
};

export type WelfareOffice = IWelfareOffice & IBaseEntity;

export const GET_WELFARE_OFFICE_BY_ID = gql`
  query getWelfareOffice($id: ID!){
    getWelfareOffice(id: $id){
      ${welfareOfficeBaseData}
    }
  }
`;

export const GET_ALL_WELFARE_OFFICES = gql`
  query getWelfareOffices {
    getWelfareOffices {
      ${welfareOfficeBaseData}
    }
  }
`;
